export { useDrawerHeaderNavigation_unstable as useDrawerHeaderNavigation } from '@fluentui/react-drawer';
